import { InitializeApp } from "./config/index.js";

import "@shared/styles/overrides.css";
import "@shared/styles/app.css";

$(document).on("Company.Initialized", function () {
	InitializeApp();
});
